import React, { Component } from 'react';
import { func, number, arrayOf } from 'prop-types';
import { connect } from 'react-redux';

import TabActions from '../../../redux/Tabs/actions';

import Tabs from './layout';
import { tabDataPropTypes } from './propTypes';

class TabsContainer extends Component {
  componentDidMount() {
    const { storeTabsData, tabData } = this.props;

    storeTabsData(tabData);
  }

  handleTabChange = (tabData) => {
    const { changeTab, onTabChange } = this.props;

    changeTab(tabData.id);
    if (onTabChange) {
      onTabChange(tabData);
    }
  };

  componentWillUnmount() {
    const { changeTab, storeTabsData } = this.props;

    changeTab(0);
    storeTabsData([]);
  }

  render() {
    const { currentTabId, tabData, children, ...props } = this.props;
    return (
      <Tabs {...props} tabData={tabData} currentTabId={currentTabId} onTabChange={this.handleTabChange}>
        {children}
      </Tabs>
    );
  }
}

TabsContainer.propTypes = {
  changeTab: func.isRequired,
  storeTabsData: func.isRequired,
  tabData: arrayOf(tabDataPropTypes).isRequired,
  currentTabId: number,
  onTabChange: func
};

const mapStateToProps = (state) => ({
  currentTabId: state.tabs.currentTabId,
  loading: state.tabs.tabsLoading
});

const mapDispatchToProps = (dispatch) => ({
  changeTab: (newTabId) => dispatch(TabActions.changeTab(newTabId)),
  storeTabsData: (steps) => dispatch(TabActions.setTabs(steps))
});

export default connect(mapStateToProps, mapDispatchToProps)(TabsContainer);
